var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"sort-item",class:{ select: _vm.current == item.type },on:{"click":function($event){return _vm.$emit('changeSort', item.type)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }